import { render, staticRenderFns } from "./FontSize.vue?vue&type=template&id=237553fa&"
import script from "./FontSize.vue?vue&type=script&lang=js&"
export * from "./FontSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports